'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useCustomReportCount, useReportCounts, useStandardReportCount } from 'reporting-action-components/data/hooks/useReportCounts';
import useCustomReportLimit from 'reporting-action-components/access/limits/hooks/useCustomReportLimit';
import useStandardReportLimit from 'reporting-action-components/access/limits/hooks/useStandardReportLimit';
import { WILL_EXCEED_CUSTOM_REPORT_LIMIT, WILL_EXCEED_STANDARD_REPORT_LIMIT, UNSUPPORTED_REPORT_TYPE } from 'reporting-action-components/reportingActions/problems';
import { LOADING_PROBLEM_AND_MESSAGE, DATA_FETCHING_ERROR_PROBLEM_AND_MESSAGE } from 'reporting-action-components/reportingActions/shared/dataProblemsAndMessages';
import { isCustom } from 'reporting-action-components/lib/report-logic';
import { getUpgradeUrl } from 'reporting-action-components/lib/linkUrls';
import { getConfigType } from 'reporting-data/report/configReportGetters';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { PIPELINE } from 'reporting-data/constants/configTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const reportIsDeprecatedFunnel = report => isConfigReport(report) && getConfigType(report) === PIPELINE;
const useRestoreReportsProblem = ({
  isSelectAll,
  reports
}) => {
  const customReportLimit = useCustomReportLimit();
  const customReportCount = useCustomReportCount();
  const standardReportLimit = useStandardReportLimit();
  const standardReportCount = useStandardReportCount();
  const selectedCustomReportCount = reports.filter(isCustom).size;
  const selectedStandardReportCount = reports.size - selectedCustomReportCount;
  const {
    loading: reportCountsLoading,
    error: reportCountsError
  } = useReportCounts();
  if (reportCountsLoading) {
    return LOADING_PROBLEM_AND_MESSAGE;
  }
  if (reportCountsError) {
    return DATA_FETCHING_ERROR_PROBLEM_AND_MESSAGE;
  }
  if (customReportCount + selectedCustomReportCount > customReportLimit) {
    return {
      problem: WILL_EXCEED_CUSTOM_REPORT_LIMIT,
      disabledMessage: isSelectAll ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'reports.restore.table.header.checkboxTooltip.willExceedCustomLimit',
        options: {
          limit: customReportLimit
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: selectedCustomReportCount === 1 ? 'reports.restore.table.checkbox.tooltip.hasReachedCustomLimit_jsx' : 'reports.restore.table.checkbox.tooltip.willExceedCustomLimit_jsx',
        options: {
          href: getUpgradeUrl(),
          limit: customReportLimit
        },
        elements: {
          UILink: Link
        }
      })
    };
  }
  if (standardReportCount + selectedStandardReportCount > standardReportLimit) {
    return {
      problem: WILL_EXCEED_STANDARD_REPORT_LIMIT,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: isSelectAll ? 'reports.restore.table.header.checkboxTooltip.willExceedStandardLimit' : selectedStandardReportCount === 1 ? 'reports.restore.table.checkbox.tooltip.hasReachedStandardLimit' : 'reports.restore.table.checkbox.tooltip.willExceedStandardLimit',
        options: {
          limit: standardReportLimit
        }
      })
    };
  }
  const selectedDeprecatedFunnelReport = reports.some(reportIsDeprecatedFunnel);
  if (selectedDeprecatedFunnelReport) {
    return {
      problem: UNSUPPORTED_REPORT_TYPE,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.restore.table.checkbox.tooltip.deprecatedFunnel"
      })
    };
  }
  return {
    problem: null,
    disabledMessage: null
  };
};
export default useRestoreReportsProblem;